import {
  EMPTY_PHONE_NUMBER_FILTER,
  PHONE_NUMBER_TOTAL_LENGTH,
  PHONE_NUMBER_WILDCARD,
  SIM_CARDS_CATEGORY_SLUG,
} from './constants';
import type { PropertyOption } from '@/hooks/useParseQuery/useParseQuery.types';

function isValidPhoneNumberFilter(value: string) {
  return (
    value.length === PHONE_NUMBER_TOTAL_LENGTH &&
    value
      .split('')
      .every(char => /^\d$/.test(char) || char === PHONE_NUMBER_WILDCARD)
  );
}

export function toPhoneNumberFilter(value: string) {
  const normalized = value.replace(/_/g, PHONE_NUMBER_WILDCARD);
  return isValidPhoneNumberFilter(normalized)
    ? normalized
    : EMPTY_PHONE_NUMBER_FILTER;
}

export function isSimCardsCategoryPath(
  categoryPath: string | null | undefined
) {
  return !!categoryPath?.endsWith(SIM_CARDS_CATEGORY_SLUG);
}

export function isPhoneNumberSearchActive(
  categoryPath: string | null | undefined,
  stringOptions: PropertyOption<string>[]
) {
  return isSimCardsCategoryPath(categoryPath) && stringOptions.length > 0;
}
